import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common'
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {RestrictionsComponent} from './restrictions.component';
import {RestrictionsRoutingModule} from './restrictions-routing.module';
import {GeneralSettingsComponent} from "./general-settings/general-settings.component";
import {SpecialSettingsComponent} from "./special-settings/special-settings.component";
import {SharedModule} from "../../shared/shared.module";
import {ModalGeneralSettingsComponent} from "./modal-general-settings/modal-general-settings.component";
import {ModalSpecialSettingsComponent} from "./modal-special-settings/modal-special-settings.component";
import {FormModalComponent} from "../../root/form-modal/form-modal.component";
import {CoreModule} from "../../core/core.module";
import {DatePickerModule} from "../../core/datepicker/datepicker.module";
import {RentalLengthSettingsComponent} from "./rental-length-settings/rental-length-settings.component";

@NgModule({
    imports: [CommonModule, CoreModule, FormsModule, RestrictionsRoutingModule,
        TranslateModule, SharedModule, DatePickerModule],
    declarations: [
        RestrictionsComponent,
        GeneralSettingsComponent,
        SpecialSettingsComponent,
        ModalGeneralSettingsComponent,
        ModalSpecialSettingsComponent,
        FormModalComponent,
        RentalLengthSettingsComponent
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class RestrictionsModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/restrictions.module.ts